import { render, staticRenderFns } from "./JVxeDepartSelectCell.vue?vue&type=template&id=23decbd8&scoped=true&"
import script from "./JVxeDepartSelectCell.vue?vue&type=script&lang=js&"
export * from "./JVxeDepartSelectCell.vue?vue&type=script&lang=js&"
import style0 from "./JVxeDepartSelectCell.vue?vue&type=style&index=0&id=23decbd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23decbd8",
  null
  
)

export default component.exports